export const getPsychoeducationModules = (t) => [
  {
    id: "cbt_model",
    title: t("psycho.cbt.title"),
    subtitle: t("psycho.cbt.subtitle"),
    icon: "brain",
    color: "from-blue-600 to-indigo-600",
    description: t("psycho.cbt.desc"),
    image: "/images/cbt-model.png",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/c82864677ed7bfdda17a2c924288539f189989d88b3f60d243d0dd88934ae754.png",
    duration: "15 min",
    sources: ["Beck, A.T. (1976). Cognitive Therapy and the Emotional Disorders.", "Beck, J.S. (2011). Cognitive Behavior Therapy: Basics and Beyond, 2nd ed."],
    sections: [
      { title: t("psycho.cbt.s1t"), content: t("psycho.cbt.s1c") },
      { title: t("psycho.cbt.s2t"), content: t("psycho.cbt.s2c") },
      { title: t("psycho.cbt.s3t"), content: t("psycho.cbt.s3c") },
      { title: t("psycho.cbt.s4t"), content: t("psycho.cbt.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.cbt.q1q"),
        options: [t("psycho.cbt.q1a"), t("psycho.cbt.q1b"), t("psycho.cbt.q1c"), t("psycho.cbt.q1d")],
        correct: 1,
        explanation: t("psycho.cbt.q1e"),
      },
      {
        question: t("psycho.cbt.q2q"),
        options: [t("psycho.cbt.q2a"), t("psycho.cbt.q2b"), t("psycho.cbt.q2c"), t("psycho.cbt.q2d")],
        correct: 1,
        explanation: t("psycho.cbt.q2e"),
      },
    ],
  },
  {
    id: "beck_anxiety",
    title: t("psycho.anx.title"),
    subtitle: t("psycho.anx.subtitle"),
    icon: "alert-triangle",
    color: "from-amber-500 to-orange-600",
    description: t("psycho.anx.desc"),
    image: "/images/beck-anxiety.jpeg",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/6e74f7956acebd8b188f8d096fc7a1f6c6fd825ff6fc40ef7901043dd70dcb2e.png",
    duration: "15 min",
    sources: ["Beck, A.T., Emery, G. & Greenberg, R.L. (1985). Anxiety Disorders and Phobias: A Cognitive Perspective.", "Clark, D.A. & Beck, A.T. (2010). Cognitive Therapy of Anxiety Disorders."],
    sections: [
      { title: t("psycho.anx.s1t"), content: t("psycho.anx.s1c") },
      { title: t("psycho.anx.s2t"), content: t("psycho.anx.s2c") },
      { title: t("psycho.anx.s3t"), content: t("psycho.anx.s3c") },
      { title: t("psycho.anx.s4t"), content: t("psycho.anx.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.anx.q1q"),
        options: [t("psycho.anx.q1a"), t("psycho.anx.q1b"), t("psycho.anx.q1c"), t("psycho.anx.q1d")],
        correct: 1,
        explanation: t("psycho.anx.q1e"),
      },
      {
        question: t("psycho.anx.q2q"),
        options: [t("psycho.anx.q2a"), t("psycho.anx.q2b"), t("psycho.anx.q2c"), t("psycho.anx.q2d")],
        correct: 1,
        explanation: t("psycho.anx.q2e"),
      },
    ],
  },
  {
    id: "beck_depression",
    title: t("psycho.dep.title"),
    subtitle: t("psycho.dep.subtitle"),
    icon: "cloud-rain",
    color: "from-slate-600 to-gray-700",
    description: t("psycho.dep.desc"),
    image: "/images/beck-depression.jpeg",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/cff57b020caa2ba8d66f550b19f6a93d2b9094ab3ac4066f44a7c55283c925a4.png",
    duration: "15 min",
    sources: ["Beck, A.T. (1967). Depression: Causes and Treatment.", "Burns, D.D. (1980). Feeling Good: The New Mood Therapy."],
    sections: [
      { title: t("psycho.dep.s1t"), content: t("psycho.dep.s1c") },
      { title: t("psycho.dep.s2t"), content: t("psycho.dep.s2c") },
      { title: t("psycho.dep.s3t"), content: t("psycho.dep.s3c") },
      { title: t("psycho.dep.s4t"), content: t("psycho.dep.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.dep.q1q"),
        options: [t("psycho.dep.q1a"), t("psycho.dep.q1b"), t("psycho.dep.q1c"), t("psycho.dep.q1d")],
        correct: 1,
        explanation: t("psycho.dep.q1e"),
      },
      {
        question: t("psycho.dep.q2q"),
        options: [t("psycho.dep.q2a"), t("psycho.dep.q2b"), t("psycho.dep.q2c"), t("psycho.dep.q2d")],
        correct: 1,
        explanation: t("psycho.dep.q2e"),
      },
    ],
  },
  {
    id: "grey_neurobiologie",
    title: t("psycho.grey.title"),
    subtitle: t("psycho.grey.subtitle"),
    icon: "zap",
    color: "from-violet-600 to-purple-700",
    description: t("psycho.grey.desc"),
    image: "/images/gray-neurobiology.png",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/9e568fe41b7b0793241eb276f7246697ab2398498f2ee604250e4414f71db992.png",
    duration: "12 min",
    sources: ["Gray, J.A. (1982). The Neuropsychology of Anxiety.", "Gray, J.A. & McNaughton, N. (2000). The Neuropsychology of Anxiety, 2nd ed."],
    sections: [
      { title: t("psycho.grey.s1t"), content: t("psycho.grey.s1c") },
      { title: t("psycho.grey.s2t"), content: t("psycho.grey.s2c") },
      { title: t("psycho.grey.s3t"), content: t("psycho.grey.s3c") },
      { title: t("psycho.grey.s4t"), content: t("psycho.grey.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.grey.q1q"),
        options: [t("psycho.grey.q1a"), t("psycho.grey.q1b"), t("psycho.grey.q1c"), t("psycho.grey.q1d")],
        correct: 1,
        explanation: t("psycho.grey.q1e"),
      },
      {
        question: t("psycho.grey.q2q"),
        options: [t("psycho.grey.q2a"), t("psycho.grey.q2b"), t("psycho.grey.q2c"), t("psycho.grey.q2d")],
        correct: 1,
        explanation: t("psycho.grey.q2e"),
      },
    ],
  },
  {
    id: "conditioning",
    title: t("psycho.cond.title"),
    subtitle: t("psycho.cond.subtitle"),
    icon: "repeat",
    color: "from-emerald-600 to-teal-600",
    description: t("psycho.cond.desc"),
    image: "/images/pavlov-conditioning.png",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/33ad7fc1a12f983eb4828b3f453314e0b9ee59fb632b8a05e1df420e25ba7957.png",
    duration: "15 min",
    sources: ["Pavlov, I.P. (1927). Conditioned Reflexes.", "Skinner, B.F. (1953). Science and Human Behavior.", "Bandura, A. (1977). Social Learning Theory."],
    sections: [
      { title: t("psycho.cond.s1t"), content: t("psycho.cond.s1c") },
      { title: t("psycho.cond.s2t"), content: t("psycho.cond.s2c") },
      { title: t("psycho.cond.s3t"), content: t("psycho.cond.s3c") },
      { title: t("psycho.cond.s4t"), content: t("psycho.cond.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.cond.q1q"),
        options: [t("psycho.cond.q1a"), t("psycho.cond.q1b"), t("psycho.cond.q1c"), t("psycho.cond.q1d")],
        correct: 1,
        explanation: t("psycho.cond.q1e"),
      },
      {
        question: t("psycho.cond.q2q"),
        options: [t("psycho.cond.q2a"), t("psycho.cond.q2b"), t("psycho.cond.q2c"), t("psycho.cond.q2d")],
        correct: 1,
        explanation: t("psycho.cond.q2e"),
      },
    ],
  },
  {
    id: "darwin_emotions",
    title: t("psycho.darwin.title"),
    subtitle: t("psycho.darwin.subtitle"),
    icon: "heart-pulse",
    color: "from-rose-600 to-pink-600",
    description: t("psycho.darwin.desc"),
    image: "/images/darwin-emotions.jpeg",
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/05c1422b20ae0528129b85e944f169e0cd7249ba94954b3dd406c3febd250b02.png",
    duration: "12 min",
    sources: ["Darwin, C. (1872). The Expression of the Emotions in Man and Animals.", "Ekman, P. (1992). An Argument for Basic Emotions. Cognition & Emotion."],
    sections: [
      { title: t("psycho.darwin.s1t"), content: t("psycho.darwin.s1c") },
      { title: t("psycho.darwin.s2t"), content: t("psycho.darwin.s2c") },
      { title: t("psycho.darwin.s3t"), content: t("psycho.darwin.s3c") },
      { title: t("psycho.darwin.s4t"), content: t("psycho.darwin.s4c") },
    ],
    quiz: [
      {
        question: t("psycho.darwin.q1q"),
        options: [t("psycho.darwin.q1a"), t("psycho.darwin.q1b"), t("psycho.darwin.q1c"), t("psycho.darwin.q1d")],
        correct: 2,
        explanation: t("psycho.darwin.q1e"),
      },
      {
        question: t("psycho.darwin.q2q"),
        options: [t("psycho.darwin.q2a"), t("psycho.darwin.q2b"), t("psycho.darwin.q2c"), t("psycho.darwin.q2d")],
        correct: 2,
        explanation: t("psycho.darwin.q2e"),
      },
    ],
  },
  {
    id: "barkley_tdah",
    title: t("psycho.barkley.title"),
    subtitle: t("psycho.barkley.subtitle"),
    icon: "heartpulse",
    color: "from-teal-600 to-emerald-600",
    description: t("psycho.barkley.desc"),
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/8b51f493eb5e5910fdceabd053b02c9b208389e9b94b41693a9a5d89b6af4b04.png",
    duration: "45 min",
    sources: ["Barkley, R.A. (2013). Defiant Children: A Clinician's Manual, 3rd ed.", "Barkley, R.A. (2015). Attention-Deficit Hyperactivity Disorder: A Handbook for Diagnosis and Treatment, 4th ed."],
    sections: [
      { title: t("psycho.barkley.s1t"), content: t("psycho.barkley.s1c") },
      { title: t("psycho.barkley.s2t"), content: t("psycho.barkley.s2c") },
      { title: t("psycho.barkley.s3t"), content: t("psycho.barkley.s3c") },
      { title: t("psycho.barkley.s4t"), content: t("psycho.barkley.s4c") },
      { title: t("psycho.barkley.s5t"), content: t("psycho.barkley.s5c") },
      { title: t("psycho.barkley.s6t"), content: t("psycho.barkley.s6c") },
      { title: t("psycho.barkley.s7t"), content: t("psycho.barkley.s7c") },
      { title: t("psycho.barkley.s8t"), content: t("psycho.barkley.s8c") },
    ],
    quiz: [
      { question: t("psycho.barkley.q1q"), options: [t("psycho.barkley.q1a"), t("psycho.barkley.q1b"), t("psycho.barkley.q1c"), t("psycho.barkley.q1d")], correct: 1, explanation: t("psycho.barkley.q1e") },
      { question: t("psycho.barkley.q2q"), options: [t("psycho.barkley.q2a"), t("psycho.barkley.q2b"), t("psycho.barkley.q2c"), t("psycho.barkley.q2d")], correct: 1, explanation: t("psycho.barkley.q2e") },
      { question: t("psycho.barkley.q3q"), options: [t("psycho.barkley.q3a"), t("psycho.barkley.q3b"), t("psycho.barkley.q3c"), t("psycho.barkley.q3d")], correct: 2, explanation: t("psycho.barkley.q3e") },
      { question: t("psycho.barkley.q4q"), options: [t("psycho.barkley.q4a"), t("psycho.barkley.q4b"), t("psycho.barkley.q4c"), t("psycho.barkley.q4d")], correct: 1, explanation: t("psycho.barkley.q4e") },
    ],
  },
  {
    id: "act_harris",
    title: t("psycho.act.title"),
    subtitle: t("psycho.act.subtitle"),
    icon: "compass",
    color: "from-cyan-600 to-teal-600",
    description: t("psycho.act.desc"),
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/7763a5dafb225bb80974e4d083cd418fbd23e293a6d38b888f898220fc6eec48.png",
    duration: "50 min",
    sources: ["Harris, R. (2009). Passez à l'ACT — Pratique de la thérapie d'acceptation et d'engagement.", "Hayes, S.C., Strosahl, K.D. & Wilson, K.G. (2012). Acceptance and Commitment Therapy, 2nd ed."],
    sections: [
      { title: t("psycho.act.s1t"), content: t("psycho.act.s1c") },
      { title: t("psycho.act.s2t"), content: t("psycho.act.s2c") },
      { title: t("psycho.act.s3t"), content: t("psycho.act.s3c") },
      { title: t("psycho.act.s4t"), content: t("psycho.act.s4c") },
      { title: t("psycho.act.s5t"), content: t("psycho.act.s5c") },
      { title: t("psycho.act.s6t"), content: t("psycho.act.s6c") },
      { title: t("psycho.act.s7t"), content: t("psycho.act.s7c") },
      { title: t("psycho.act.s8t"), content: t("psycho.act.s8c") },
    ],
    quiz: [
      { question: t("psycho.act.q1q"), options: [t("psycho.act.q1a"), t("psycho.act.q1b"), t("psycho.act.q1c"), t("psycho.act.q1d")], correct: 1, explanation: t("psycho.act.q1e") },
      { question: t("psycho.act.q2q"), options: [t("psycho.act.q2a"), t("psycho.act.q2b"), t("psycho.act.q2c"), t("psycho.act.q2d")], correct: 2, explanation: t("psycho.act.q2e") },
      { question: t("psycho.act.q3q"), options: [t("psycho.act.q3a"), t("psycho.act.q3b"), t("psycho.act.q3c"), t("psycho.act.q3d")], correct: 0, explanation: t("psycho.act.q3e") },
      { question: t("psycho.act.q4q"), options: [t("psycho.act.q4a"), t("psycho.act.q4b"), t("psycho.act.q4c"), t("psycho.act.q4d")], correct: 2, explanation: t("psycho.act.q4e") },
    ],
  },
  {
    id: "tdah_adulte",
    title: t("psycho.tdah.title"),
    subtitle: t("psycho.tdah.subtitle"),
    icon: "zap",
    color: "from-orange-500 to-amber-600",
    description: t("psycho.tdah.desc"),
    sectionImage: "https://static.prod-images.emergentagent.com/jobs/b2520196-a3fe-49ef-8210-27c702bd03c1/images/6f2642a078b3b8bac605cf559d94196566b2c79c001ad613a7a95d5d40f99e53.png",
    duration: "50 min",
    sources: [
      "Safren, S.A., Perlman, C.A., Sprich, S. & Otto, M.W. (2006). Mastering Your Adult ADHD: A Cognitive-Behavioral Treatment Program.",
      "Barkley, R.A. (2015). Attention-Deficit Hyperactivity Disorder: A Handbook for Diagnosis and Treatment, 4th ed.",
      "TCCMontréal (2020). Guide TCC pour le TDAH — Manuel du patient.",
      "Ramsay, J.R. & Rostain, A.L. (2015). Cognitive-Behavioral Therapy for Adult ADHD, 2nd ed.",
    ],
    sections: [
      { title: t("psycho.tdah.s1t"), content: t("psycho.tdah.s1c") },
      { title: t("psycho.tdah.s2t"), content: t("psycho.tdah.s2c") },
      { title: t("psycho.tdah.s3t"), content: t("psycho.tdah.s3c") },
      { title: t("psycho.tdah.s4t"), content: t("psycho.tdah.s4c") },
      { title: t("psycho.tdah.s5t"), content: t("psycho.tdah.s5c") },
      { title: t("psycho.tdah.s6t"), content: t("psycho.tdah.s6c") },
      { title: t("psycho.tdah.s7t"), content: t("psycho.tdah.s7c") },
      { title: t("psycho.tdah.s8t"), content: t("psycho.tdah.s8c") },
    ],
    quiz: [
      { question: t("psycho.tdah.q1q"), options: [t("psycho.tdah.q1a"), t("psycho.tdah.q1b"), t("psycho.tdah.q1c"), t("psycho.tdah.q1d")], correct: 2, explanation: t("psycho.tdah.q1e") },
      { question: t("psycho.tdah.q2q"), options: [t("psycho.tdah.q2a"), t("psycho.tdah.q2b"), t("psycho.tdah.q2c"), t("psycho.tdah.q2d")], correct: 1, explanation: t("psycho.tdah.q2e") },
      { question: t("psycho.tdah.q3q"), options: [t("psycho.tdah.q3a"), t("psycho.tdah.q3b"), t("psycho.tdah.q3c"), t("psycho.tdah.q3d")], correct: 0, explanation: t("psycho.tdah.q3e") },
      { question: t("psycho.tdah.q4q"), options: [t("psycho.tdah.q4a"), t("psycho.tdah.q4b"), t("psycho.tdah.q4c"), t("psycho.tdah.q4d")], correct: 3, explanation: t("psycho.tdah.q4e") },
    ],
  },
];

// Keep backward compatible static export
export const PSYCHOEDUCATION_MODULES = null;
